var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: _vm.element } },
    [
      _c(
        "v-app",
        [
          _c(
            "v-main",
            [
              _c("aspediacrm-grid", {
                attrs: { map: _vm.map, "global-context": _vm.globalContext },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }